const IceBoxPalletList = () => import('Views/iceBoxPallet/iceBoxPallet-list');
const IceBoxPalletAddEdit = () => import('Views/iceBoxPallet/iceBoxPallet-addEdit');
const IceBoxPalletDetail = () => import('Views/iceBoxPallet/iceBoxPallet-detail');

export default[
  { path: '/iceBoxPallet-list', component: IceBoxPalletList },
  { path: '/iceBoxPallet-add', component: IceBoxPalletAddEdit },
  { path: '/iceBoxPallet-edit/:id', component: IceBoxPalletAddEdit },
  { path: '/iceBoxPallet-detail/:id', component: IceBoxPalletDetail },
];



// WEBPACK FOOTER //
// ./src/router/iceBoxPallet.js